import styled, { css, keyframes } from 'styled-components';

const wobble = keyframes`
  10%, 90% {
    transform: translate(-50.5%);
  }

  20%, 80% {
    transform: translate(-49.5%);
  }

  30%, 50%, 70% {
    transform: translate(-53%);
  }

  40%, 60% {
    transform: translate(-47%);
  }
`;

export const StyledLoginModal = styled.div`
  background: rgba(251, 251, 251, 0.95);
  border-radius: 3px;
  border: 1px solid #ebebeb;
  bottom: 76.5px;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
  left: 50%;
  max-width: 416px;
  opacity: ${props => (props.isVisible ? '1' : '0')};
  padding: 1em 1.25em;
  position: absolute;
  text-align: center;
  transform: translate(-50%);
  transition: visibility 0.3s ease, opacity 0.3s ease;
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  z-index: 5000;

  animation: ${props =>
    props.isWobble &&
    css`
      ${wobble} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both
    `};

  > p {
    margin: 0;

    > a {
      color: #0f4c81;

      &:hover {
        color: #177dd6;
      }
    }
  }
`;
